import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { PiSidebarBold } from "react-icons/pi";
import { TbEdit } from "react-icons/tb";
import "./Sidebar.css";
import { isLast30Days, isLast7Days, isToday } from "../../common/common";
// import Select from "react-select";
// import StepperComponent from "../../pages/Exit/Stepper/StepperComponent";
import { FaEdit, FaExclamationTriangle, FaCalculator } from "react-icons/fa";
import PensionPlusCalculator from "../../components/PensionPlusCalculator";
// import S2Form from "../S2Form/S2Form";

function Sidebar({
  points,
  setSidebar,
  sidebar,
  onNewChat,
  history,
  setSelectHistory,
  selectHistory,
  selectedOption,
  setSelectedOption,
  categoryDropdown,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [width, setWidth] = useState(window.innerWidth);

  // const [showExitModal, setShowExitModal] = useState(false);

  const [showCalculatorModal, setShowCalculatorModal] = useState(false);

  // const [showS2Modal, setShowS2Modal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setSidebar(window.innerWidth >= 1080);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setSidebar]);

  const handleHide = () => {
    if (window.innerWidth <= 1080) {
      setSidebar(false);
    }
  };

  const handleShow = (e) => {
    e.preventDefault();
    setSidebar(true);
  };

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const handleExit = () => {
    navigate("/exit2");
  };

  // const clearAllExitFormData = () => {
  //   try {
  //     localStorage.removeItem("exitFormSectionA");

  //     localStorage.removeItem("exitFormSectionB");

  //     localStorage.removeItem("exitFormSectionC");

  //     localStorage.removeItem("exitFormSectionD");

  //     localStorage.removeItem("exitFormSectionE");

  //     localStorage.removeItem("exitFormSectionF");

  //     localStorage.removeItem("exitFormSectionG");

  //     Object.keys(localStorage).forEach((key) => {
  //       if (key.startsWith("exitForm")) {
  //         localStorage.removeItem(key);
  //       }
  //     });
  //   } catch (error) {
  //     console.error("Error clearing stored form data:", error);
  //   }
  // };

  // const handleCancelExit = () => {
  //   clearAllExitFormData();
  //   setShowExitModal(false);
  // };

  // const handleStepperComplete = () => {
  //   clearAllExitFormData();
  //   setShowExitModal(false);
  // };

  /*
   * ---------------------------------------------------------
   * CATEGORY DROPDOWN
   * ---------------------------------------------------------
   */

  const formatOptions = (data) => {
    return data.map((category) => {
      if (category.SubCategories.length > 0) {
        return {
          label: category.CategoryType,
          options: category.SubCategories.map((sub) => ({
            value: `subcategory-${sub.SubCategoryID}`,
            label: sub.SubCategoryType,
            categoryId: category.CategoryID,
            SubCategoryID: sub.SubCategoryID,
            isSubcategory: true,
          })),
        };
      }

      return {
        value: `category-${category.CategoryID}`,
        label: category.CategoryType,
        isSubcategory: false,
        categoryId: category.CategoryID,
        SubCategoryID: 0,
      };
    });
  };

  const options = formatOptions(categoryDropdown);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#373333",
      color: "white",
      borderColor: state.isFocused ? "white" : "gray",
      borderRadius: "8px",
      boxShadow: state.isFocused ? "0 0 0 1px white" : "none",
      "&:hover": {
        borderColor: "white",
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "white",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#ccc",
    }),

    menu: (provided) => ({
      ...provided,
      backgroundColor: "#373333",
      color: "white",
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#444"
        : state.isFocused
          ? "#222"
          : "#373333",
      color: state.isSelected ? "#059669" : "white",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#333",
      },
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: "white",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    input: (provided) => ({
      ...provided,
      color: "white",
    }),
  };

  /*
   * ---------------------------------------------------------
   * S2 FORM
   * ---------------------------------------------------------
   */

  return (
    <>
      {!sidebar && (
        <div onClick={handleShow}>
          <PiSidebarBold className="close-window chatgpt-show" />
        </div>
      )}

      {sidebar && (
        <div className={`sidebar ${sidebar ? "active" : ""}`}>
          {/* =================================================
              SIDEBAR HEADER
          ================================================= */}

          <div
            className="icons"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              gap: "8px",
            }}
          >
            <div
              className="left-icon tooltip-sidebar d-flex align-items-center justify-content-center"
              style={{
                padding: "4px",
                cursor: "pointer",
                borderRadius: "8px",
              }}
              onClick={handleHide}
            >
              <PiSidebarBold
                className="close-window"
                size={22}
                color="#e5e7eb"
              />

              {window.innerWidth <= 1080 && (
                <span className="tooltip-text tooltop-left">Close sidebar</span>
              )}
            </div>

            {width <= 440 && (
              <div>
                <h5 className="m-0 sidebar-points">Points : {points}</h5>
              </div>
            )}

            <motion.button
              className="d-flex align-items-center justify-content-center"
              onClick={onNewChat}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "#e5e7eb",
                cursor: "pointer",
              }}
              whileHover={{
                scale: 1.05,
                color: "#ffffff",
              }}
              whileTap={{
                scale: 0.95,
              }}
            >
              <TbEdit size={24} />
            </motion.button>
          </div>

          {/* =================================================
              PRE-MATURE EXIT
          ================================================= */}

          <div
            style={{
              padding: "4px",
              fontSize: "0.9rem",
            }}
          >
            <motion.button
              type="button"
              className={`sidebar-new-chat ${
                location.pathname === "/exit2" ? "sidebar-active-tab" : ""
              }`}
              onClick={handleExit}
              whileHover={{
                scale: 1.02,
                x: 4,
              }}
              whileTap={{
                scale: 0.98,
              }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 17,
              }}
            >
              <FaEdit size={18} className="sidebar-icon" />
              NPS, Pre-mature Exit form
            </motion.button>
          </div>

          {/* =================================================
              NPS CALCULATOR
          ================================================= */}

          <div
            style={{
              padding: "4px",
              fontSize: "0.9rem",
            }}
          >
            <motion.button
              type="button"
              className={`sidebar-new-chat ${
                location.pathname === "/nps-calculator" ? "sidebar-active-tab" : ""
              }`}
              onClick={() => {
                navigate("/nps-calculator");

                if (window.innerWidth < 1080) {
                  setSidebar(false);
                }
              }}
              whileHover={{
                scale: 1.02,
                x: 4,
              }}
              whileTap={{
                scale: 0.98,
              }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 17,
              }}
            >
              <FaCalculator size={18} className="sidebar-icon" />
              NPS Calculator
            </motion.button>
          </div>

          {/* =================================================
              S2 FORM
          ================================================= */}

          <div
            style={{
              padding: "4px",
              fontSize: "0.9rem",
            }}
          >
            <motion.button
              type="button"
              className={`sidebar-new-chat ${
                location.pathname === "/s2-form" ? "sidebar-active-tab" : ""
              }`}
              onClick={() => {
                navigate("/s2-form");

                if (window.innerWidth < 1080) {
                  setSidebar(false);
                }
              }}
              whileHover={{
                scale: 1.02,
                x: 4,
              }}
              whileTap={{
                scale: 0.98,
              }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 17,
              }}
            >
              <TbEdit size={18} className="sidebar-icon" />
              S2 Form
            </motion.button>
          </div>

          {/* =================================================
                             EXIT FORM
              ================================================= */}

          <div
            style={{
              padding: "4px",
              fontSize: "0.9rem",
            }}
          >
            <motion.button
              type="button"
              className={`sidebar-new-chat ${location.pathname === "/exit" ? "sidebar-active-tab" : ""}`}
              onClick={() => {
                if (location.pathname !== "/exit") {
                  navigate("/exit");
                }

                if (window.innerWidth < 1080) {
                  setSidebar(false);
                }
              }}
              whileHover={{
                scale: 1.02,
                x: 4,
              }}
              whileTap={{
                scale: 0.98,
              }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 17,
              }}
            >
              <FaEdit size={18} className="sidebar-icon" />
              Exit Form
            </motion.button>
          </div>
          {/* =================================================
              EXISTING CATEGORY CODE
          ================================================= */}

          {/*
          {width >= 440 ? (
            <div
              style={{
                padding: "4px",
                fontSize:
                  "0.9rem"
              }}
            >
              <motion.button
                className="sidebar-new-chat"
                onClick={
                  onNewChat
                }
                whileHover={{
                  scale: 1.02,
                  x: 4
                }}
                whileTap={{
                  scale: 0.98
                }}
                transition={{
                  type:
                    "spring",
                  stiffness:
                    400,
                  damping: 17
                }}
              >
                <PiSpinnerBallFill
                  size={18}
                  className="sidebar-icon"
                />

                Advisor
              </motion.button>
            </div>
          ) : (
            <div className="sidebar-category">
              <Select
                inputId="react-select"
                options={
                  options
                }
                value={
                  selectedOption
                }
                onChange={
                  handleChange
                }
                placeholder="Select..."
                isClearable
                styles={
                  customStyles
                }
              />
            </div>
          )}
          */}

          {/* =================================================
              HISTORY
          ================================================= */}

          <div className="content">
            {history?.length > 0 && (
              <div className="sub-content">
                {/* TODAY */}

                {history.find((item) => isToday(item.date)) && (
                  <p
                    className="f-size"
                    style={{
                      fontSize: "0.8rem",
                    }}
                  >
                    Today
                  </p>
                )}

                {history
                  .filter((item) => isToday(item.date))
                  .map((item, idx) => (
                    <p
                      key={`today-${idx}`}
                      className={`title-truncate ${
                        selectHistory?.date === item?.date &&
                        selectHistory?.title &&
                        item?.title
                          ? "select-history"
                          : "title-truncate:hover"
                      }`}
                      onClick={() => {
                        setSelectHistory(item);

                        if (window.innerWidth < 1080) {
                          setSidebar(false);
                        }
                      }}
                    >
                      {item.title}
                    </p>
                  ))}

                {/* PREVIOUS 7 DAYS */}

                {history.find((item) => isLast7Days(item.date)) && (
                  <p
                    className="f-size"
                    style={{
                      fontSize: "0.8rem",
                    }}
                  >
                    Previous 7 Days
                  </p>
                )}

                {history
                  .filter((item) => isLast7Days(item.date))
                  .map((item, idx) => (
                    <p
                      key={`last7-${idx}`}
                      className={`title-truncate ${
                        selectHistory?.date === item?.date &&
                        selectHistory?.title &&
                        item?.title
                          ? "select-history"
                          : "title-truncate:hover"
                      }`}
                      onClick={() => {
                        setSelectHistory(item);

                        if (window.innerWidth < 1080) {
                          setSidebar(false);
                        }
                      }}
                    >
                      {item.title}
                    </p>
                  ))}

                {/* PREVIOUS 30 DAYS */}

                {history.find((item) => isLast30Days(item.date)) && (
                  <p
                    className="f-size"
                    style={{
                      fontSize: "0.8rem",
                    }}
                  >
                    Previous 30 Days
                  </p>
                )}

                {history
                  .filter((item) => isLast30Days(item.date))
                  .map((item, idx) => (
                    <p
                      key={`last30-${idx}`}
                      className={`title-truncate ${
                        selectHistory?.date === item?.date &&
                        selectHistory?.title &&
                        item?.title
                          ? "select-history"
                          : "title-truncate:hover"
                      }`}
                      onClick={() => {
                        setSelectHistory(item);

                        if (window.innerWidth < 1080) {
                          setSidebar(false);
                        }
                      }}
                    >
                      {item.title}
                    </p>
                  ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* =====================================================
          EXISTING EXIT FORM MODAL
      ===================================================== */}

      {/* {showExitModal && (
        <div className="exit-modal-overlay">
          <div className="exit-modal-box exit-modal-box-stepper">
            <button
              className="exit-modal-close-btn"
              onClick={handleCancelExit}
              aria-label="Close"
            >
              <i className="fas fa-times"></i>
            </button>

            <StepperComponent
              onClose={handleCancelExit}
              onComplete={handleStepperComplete}
            />
          </div>
        </div>
      )} */}

      {/* =====================================================
          CALCULATOR MODAL
      ===================================================== */}

      {showCalculatorModal && (
        <div
          className="exit-modal-overlay"
          style={{
            zIndex: 10001,
          }}
        >
          <div className="pension-calculator-modal-wrapper">
            <button
              className="exit-modal-close-btn"
              onClick={() => setShowCalculatorModal(false)}
              aria-label="Close"
              style={{
                zIndex: 20,
              }}
            >
              <i className="fas fa-times"></i>
            </button>

            <PensionPlusCalculator
              onClose={() => setShowCalculatorModal(false)}
            />
          </div>
        </div>
      )}
      {/* =====================================================
          S2 FORM MODAL
      ===================================================== */}

      {/* {showS2Modal && (
        <div className="exit-modal-overlay">
          <div className="exit-modal-box exit-modal-box-stepper">
            <button
              className="exit-modal-close-btn"
              onClick={() => setShowS2Modal(false)}
              aria-label="Close"
              style={{ zIndex: 20 }}
            >
              <i className="fas fa-times"></i>
            </button>

            <S2Form
              onClose={() => setShowS2Modal(false)}
              onComplete={() => {
                setShowS2Modal(false);
              }}
            />
          </div>
        </div>
      )} */}
    </>
  );
}

export default Sidebar;
